
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["runChatTrimmer","countTokensForText","countTokensForMessages"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "068d978da14a5d07fab6.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "068d978da14a5d07fab6.worker.js");
					addMethods(w, methods)
					
					return w
				}
			